import type { IEmployeeRepository } from '../../domain/repositories/IEmployeeRepository';
import { CompositeEmployeeRepository } from './CompositeEmployeeRepository';

let instance: IEmployeeRepository | null = null;

export function getEmployeeRepository(): IEmployeeRepository {
  if (!instance) {
    instance = new CompositeEmployeeRepository();
  }
  return instance;
}
